import { useMutation } from "react-query";
import { apiPost } from "@shared/queryHooks/api";

const createJobResumeExport = async ({ jobId }) => {
  return await apiPost({ path: `/jobs/${jobId}/job_resume_export`, variables: {} });
};

// Status code mapping for onError handlers in callers:
// 402 = plan gate (frontend shows upgrade toast w/ tier name from useFeatureGate)
// 409 = export already in progress
// 422 = empty job (no resumes uploaded) — render server message as kind: info
function useCreateJobResumeExport() {
  return useMutation(createJobResumeExport, {});
}

export { useCreateJobResumeExport };
